import { StaffManagementStoreV2 } from '@coursera-web/staff-management';
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import MarketingEmailsStore from 'bundles/admin-marketing-emails/stores/MarketingEmailsStore';
import CourseCreationMessageStore from 'bundles/admin-v2/components/course-creation/stores/CourseCreationMessageStore';
import CourseMaterialStore from 'bundles/author-course/stores/CourseMaterialStore';
import AuthoringPartnerStore from 'bundles/author-partner/stores/AuthoringPartnerStore';
import ItemStateStore from 'bundles/authoring/common/stores/ItemStateStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import CustomRoleStore from 'bundles/teach-partner-2018/custom-roles/stores/CustomRoleStore';

import 'css!bundles/global-styles/global-element-styles';

import routes from './routes';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(NaptimeStore);
appEnv.registerStore(AuthoringPartnerStore);
appEnv.registerStore(MarketingEmailsStore);
appEnv.registerStore(ApplicationStore);
appEnv.registerStore(ItemStateStore);
appEnv.registerStore(CourseCreationMessageStore);

appEnv.registerStore(CustomRoleStore);
appEnv.registerStore(StaffManagementStoreV2);

appEnv.registerStore(CourseMaterialStore);

export default appEnv;
